export * from "./furMaterial.js";
//# sourceMappingURL=index.js.map